import {readable, get} from 'svelte/store';
import {navigate} from "svelte-routing";
import {
    authToken,
    sessionStorageSet,
    flashError,
    flashSuccess,
    flashSuccessMessage,
    flashErrorMessage
} from "./stores.js";

function clearFlash() {
    flashSuccess.set(null);
    flashError.set(null);
    flashSuccessMessage.set(null);
    flashErrorMessage.set(null);
}

export let backendurl = '';
export let baseurl = '';

// Prod - ota nämä käyttöön, kun teet prod pakettia
//export let backendurl = 'https://www.dynamosali.com:8443';
//export let baseurl = 'https://www.dynamosali.com/crm';

// Local - käytä näitä vain lokaalissa
//export let backendurl = 'http://localhost:8080';
//export let baseurl = 'http://localhost:5000';

if (isProduction) {
    console.log('## Production Mode ##############################');
    backendurl = 'https://www.dynamosali.com:8443';
    baseurl = 'https://www.dynamosali.com/crm';
} else {
    console.log('## Developement Mode ##############################');
    backendurl = 'http://localhost:8080';
    baseurl = 'http://localhost:5000';
}

export let basePath = '/';
let errorMessageValue;
let successMessageValue;

const unsubscribeError = flashErrorMessage.subscribe(value => {
    errorMessageValue = value;
});
const unsubscribeSuccess = flashSuccessMessage.subscribe(value => {
    successMessageValue = value;
});

function showFlashErrorMessage(m) {
    let message = "Voi ei! Jotain meni pieleen!";
    if (m === undefined && (errorMessageValue == undefined || errorMessageValue === null || errorMessageValue == "")) {
        //console.log("showFlashErrorMessage :: error 1");
        flashErrorMessage.set("Voi ei! Jotain meni pieleen!!");
    } else if (m != undefined && m !== null && m != "") {
        //console.log("showFlashErrorMessage :: error 2");
        flashErrorMessage.set(m);
    } else if (errorMessageValue != undefined && errorMessageValue !== null && errorMessageValue !== "") {
        // Ei tehdä mitään, koska tänä on haluttu tila - Virhe osataan näyttää oikein
        //console.log("showFlashErrorMessage :: error 3 :: errorMessageValue: ",errorMessageValue, (errorMessageValue != undefined), (errorMessageValue !== null) , (errorMessageValue !== ""));
    } else {
        flashErrorMessage.set(message);
        //console.log("showFlashErrorMessage :: error 4");
    }

    // Näytetään virhe
    flashError.set(errorMessageValue);
    //console.log("showFlashErrorMessage :: errorMessageValue", errorMessageValue);

    //Siivotaan virhe 7 sek päästä
    setTimeout(clearFlash, 7000);
}

function showFlashSuccessMessage(m) {
    let message = "Homma ok!";
    if (m === undefined && (successMessageValue == undefined || successMessageValue === null || successMessageValue == "")) {
        flashSuccessMessage.set("Onnistui!");
    } else if (m != undefined && m !== null && m != "") {
        flashSuccessMessage.set(m);
    } else if (successMessageValue != undefined && successMessageValue !== null && successMessageValue != "") {
        // Ei tehdä mitään, koska tänä on haluttu tila
    } else {
        flashSuccessMessage.set(message);
    }

    // Näytetään onnistuminen
    flashSuccess.set(successMessageValue);

    //Siivotaan flash 7 sek päästä
    setTimeout(clearFlash, 7000);
}

export async function GET(path) {
    const getHeaders = new Headers();
    if (get(authToken) && get(authToken).length > 1) {
        getHeaders.append('Authorization', 'Bearer ' + get(authToken));
    }
    getHeaders.append('Accept', 'application/json');
    const response = await fetch(backendurl + path, {
        method: 'GET',
        headers: getHeaders
    }).catch(error => {
        // Network error - Käsitellään se hieman eri tavalla
        console.log("Varmaankin verkkovirhe :: error:", error);
    });

    let checkResponse = await response;
    if(checkResponse) {

        if (checkResponse && checkResponse.status && checkResponse.status === 400) {
            console.log("ERROR 400");
            setTimeout(showFlashErrorMessage, 100);
        } else if (checkResponse && checkResponse.status && checkResponse.status === 401) {
            console.log("ERROR 401");
            navigate(basePath + 'kirjaudu');

            setTimeout(showFlashErrorMessage, 100);
        } else if (checkResponse && checkResponse.status && checkResponse.status !== 200) {
            console.log("ERROR ", responseStatusCode);
            setTimeout(showFlashErrorMessage, 100);
        } else {
            setTimeout(showFlashSuccessMessage, 100);
            return checkResponse.json();
        }
    }

    //Siivotaan flash 7 sek päästä
    setTimeout(clearFlash, 7000);
}

export async function POST(path, body = '', showFlashMessage = true) {
    const postHeaders = new Headers();
    if (get(authToken) && get(authToken) != null && get(authToken).length > 1) {
        postHeaders.append('Authorization', 'Bearer ' + get(authToken));
    }
    postHeaders.append('Content-Type', 'application/json');
    postHeaders.append('Accept', 'application/json');

    const response = await fetch(backendurl + path, {
        method: 'POST',
        headers: postHeaders,
        body: body
    }).catch(error => {
        // Network error - Käsitellään se hieman eri tavalla
        console.log("Varmaankin verkkovirhe :: error:", error);
    });

    let checkResponse = await response;
    let responseStatusCode;
    if (checkResponse) {
        responseStatusCode = checkResponse.status;
        if (responseStatusCode === 401) {
            setTimeout(showFlashErrorMessage, 100);
            console.log("ERROR 401");
        } else if (responseStatusCode === 500) {
            setTimeout(showFlashErrorMessage, 100);
            console.log("ERROR 500");
        } else if (responseStatusCode === 200) {
            setTimeout(showFlashSuccessMessage, 100);
            return checkResponse.json();
        } else {
            setTimeout(showFlashErrorMessage, 100);
            return checkResponse.json();
        }
    } else {
        console.log("POST! :: error!! ");
        setTimeout(showFlashErrorMessage, 100);
    }

    //Siivotaan flash 7 sek päästä
    setTimeout(clearFlash, 7000);
}
